import {FC} from 'react';
import {Nav, NavDrawer} from '../Nav';
import {headerCssClassNames} from './headerCssClassNames';
import {useHeaderState} from './HeaderStateContext';

export const HeaderNavigation: FC<unknown> = () => {
    const {
        navigationPosition,
        navigationItems,
        isSmallMobile, isMobile, isTablet,
        isContained,
        isMobileMenuOpen,
        mobileMenuPosition,
        handleMobileMenuClose
    } = useHeaderState();

    const showMobileMenu = isSmallMobile || isMobile || isTablet;

    return showMobileMenu ? (
        <NavDrawer
            aria-label='App Mobile Menu'
            className={headerCssClassNames.mobileNavigation}
            items={navigationItems}
            onClose={handleMobileMenuClose}
            open={isMobileMenuOpen}
            position={mobileMenuPosition}
        />
    ) : (
        <Nav
            aria-label='App Navigation'
            className={headerCssClassNames.navigation}
            isContained={isContained}
            items={navigationItems}
            variant={navigationPosition}
        />
    );
};

HeaderNavigation.displayName = 'HeaderNavigation';
